import React, { ReactNode }                         from "react";
import { connect }                                  from "react-redux";
import MenuType                                     from "../../../domain/menu/MenuType";
import { ResKaState }                               from "../../../index";
import Breadcrumbs                                  from "../../components/common/Breadcrunmbs";
import TopSection                                   from "../../components/common/layout/TopSection";
import CustomerRecordsTab                           from "../../components/customer/record/CustomerRecordsTab";
import ResKaBaseContainer, { BaseProps, BaseState } from "../ResKaBaseContainer";

class CustomerRecordsContainer extends ResKaBaseContainer<BaseProps, BaseState> {
  constructor(props: BaseProps) {
    const state = {
      headerTitle: "顧客編集",
      menuType: MenuType.CUSTOMER,
    };

    super(props, state);
  }

  protected componentDidMountInternal(): void {
  }

  protected renderInternal(): ReactNode {
    return (
      <>
        <TopSection>
          <Breadcrumbs breadcrumbs={
            [
              {
                title: "顧客一覧",
                path: "/customers"
              },
              {
                title: "記録情報",
                path: "/customer/records"
              },
            ]
          }/>
        </TopSection>

        <CustomerRecordsTab/>
      </>
    );
  }

}

const mapStateToProps = (state: ResKaState) => ({
  fetchStatus: state.fetchStatus,
});

export default connect(mapStateToProps)(CustomerRecordsContainer);
